import { tuple } from '../_utils/type';
export var Statuses = tuple('wait', 'process', 'finish', 'error');
export var Directions = tuple('horizontal', 'vertical');
export var LabelPlacements = tuple('left', 'right', 'top', 'bottom');